/** API context: typed endpoints and the SSE factory (real network or the mock backend). */
import { createContext, useContext } from 'react';
import type { ClientEndpoints } from './client_endpoints';
import type { EventSourceFactory } from './live_stream';

export interface ApiContextValue {
  endpoints: ClientEndpoints;
  createEventSource: EventSourceFactory;
}

export const ApiContext = createContext<ApiContextValue | null>(null);

export class MissingApiProviderError extends Error {
  constructor() {
    super('useApi must be used inside <ApiProvider>');
    this.name = 'MissingApiProviderError';
  }
}

export function useApi(): ApiContextValue {
  const apiContextValue = useContext(ApiContext);
  if (apiContextValue === null) {
    throw new MissingApiProviderError();
  }
  return apiContextValue;
}

export function useEndpoints(): ClientEndpoints {
  return useApi().endpoints;
}
